import { safeJsonParseObject } from "../../utils/json";

export const parseClientStatusPayload = (value: unknown) => {
	const parsed = typeof value === "string" ? safeJsonParseObject<Record<string, unknown>>(value, {}) : value;
	const payload = parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed as Record<string, unknown> : {};
	return {
		old_status: typeof payload.old_status === "string" ? payload.old_status : "",
		new_status: typeof payload.new_status === "string" ? payload.new_status : "",
		reason: typeof payload.reason === "string" ? payload.reason : "",
	};
};
